import { css } from 'styled-components'

type CustomExtendedProps = {
  monospace?: boolean
  uppercase?: boolean
  capitalize?: boolean
  ellipsis?: boolean
  nowrap?: boolean
  preWrap?: boolean
  balanceWrap?: boolean
}

const monospaceCss = ({ monospace }: CustomExtendedProps) =>
  monospace &&
  css`
    font-feature-settings: 'tnum' on, 'lnum' on;
  `

const uppercaseCss = ({ uppercase }: CustomExtendedProps) =>
  uppercase &&
  css`
    text-transform: uppercase;
  `

const capitalizeCss = ({ capitalize }: CustomExtendedProps) =>
  capitalize &&
  css`
    text-transform: capitalize;
  `

const ellipsisCss = ({ ellipsis }: CustomExtendedProps) =>
  ellipsis &&
  css`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  `

const nowrapCss = ({ nowrap }: CustomExtendedProps) =>
  nowrap &&
  css`
    white-space: nowrap;
  `

const preWrapCss = ({ preWrap }: CustomExtendedProps) =>
  preWrap &&
  css`
    white-space: pre-wrap;
  `

const balanceWrapCss = ({ balanceWrap }: CustomExtendedProps) =>
  balanceWrap &&
  css`
    text-wrap: balance;
  `

export type { CustomExtendedProps }
export {
  balanceWrapCss,
  capitalizeCss,
  ellipsisCss,
  monospaceCss,
  nowrapCss,
  preWrapCss,
  uppercaseCss,
}
